require("!!../../../../../node_modules/script-loader/addScript.js")(require("!!../../../../../node_modules/raw-loader/index.js!./input.js"))